<template>
  <div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgb(35, 36, 72);
        color: #fff;
        padding: 10px 10px;
      "
      class="mt-2">
      <div style="display: flex;align-items: center;">
        <span class="current_img"><img :src="skin_icon" /></span>
        <div style="margin-right: 20px">
          <div style="max-width: 500px;">{{ hero_name + "-" + skin_name }}</div>
        </div>
        <div>
          皮肤等级：<span class="fw-bold">{{ level }}</span>
        </div>
        <div class="ms-4">
          皮肤品质：<span class="fw-bold">{{ skinQuality }}</span>
        </div>
      </div>

      <div class="d-flex">
        <router-link :to="{name: 'device-manage'}" class="me-4">
          <el-button type="primary" size="mini">管理设备</el-button>
        </router-link>

        <el-button
          v-if="checkHok"
          type="primary"
          size="mini"
          @click="checkHok = false">切换英雄皮肤</el-button>
        <el-form :inline="true" size="mini" v-else>
          <el-form-item label="选择英雄">
            <el-select
              @change="skin_id = ''"
              filterable
              v-model="hero_id">
              <el-option
                v-for="item in hokIcon?.hero_list"
                :key="item.hero_id"
                :label="item.hero_name"
                :value="item.hero_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择皮肤">
            <el-select v-model="skin_id">
              <el-option
                v-for="item in hokIcon?.skin_list[hero_id]"
                :key="item.skin_id"
                :label="item.skin_name"
                :value="item.skin_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="confirm()">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <in-table
      ref="tableRef"
      :skin-id="skin_id"
      :poster-url="posterUrl"
      :poster-more-url="posterMoreUrl"
      :type="$route?.query?.type"
      :metricColumns="metricColumns"
      class="mt-3"
    />
  </div>
</template>

<script>
import InTable from './in-table.vue'

export default {
  components: {
    InTable,
  },

  props: {
    isLingbao: {
      type: Boolean,
    },
    hokIcon: {
      type: Object,
    },
  },

  data() {
    return {
      posterUrl: '/report/in_skin_data_v3/',
      posterMoreUrl: '/report/in_skin_data_more_v3/',
      skin_id: "",
      hero_id: "",
      checkHok: true,
      hero_name: '',
      skin_name: '',
      skin_icon: '',
      level: '',
      skinQuality: '',
    }
  },

  computed: {
    metricColumns() {
      return this.isLingbao ? [
        { label: '平均帧率(高于)', key: 'avg_fps' },
        { label: '低帧率占比(低于)', key: 'fps_lt_40_pcnt' },
        { label: '最低帧率(高于)', key: 'min_fps' },
        { label: 'CPU占用率均值(低于)', key: 'avg_cpu' },
        { label: '内存峰值(低于)', key: 'max_pss' },
        { label: '内存均值', key: 'avg_pss' },
        { label: '帧率方差(低于)', key: 'var_fps' },
      ] : [
        { label: '平均帧率(高于)', key: 'avg_fps' },
        { label: '低帧率占比(低于)', key: 'fps_lt_40_pcnt' },
        { label: '最低帧率(高于)', key: 'min_fps' },
        { label: 'CPU占用率均值(低于)', key: 'avg_cpu' },
        { label: '内存峰值(低于)', key: 'max_pss' },
        { label: "卡顿率(低于)", key: "caton" },
        { label: '内存均值', key: 'avg_pss' },
        { label: '帧率方差(低于)', key: 'var_fps' },
      ]
    },
  },

  watch: {
    hokIcon() {
      const queryHeroId = this.$route.query.hero_id
      const querySkinId = this.$route.query.skin_id
      this.hero_id = queryHeroId ? queryHeroId : this.hokIcon?.hero_list?.[0].hero_id
      this.skin_id = querySkinId ? querySkinId : this.hokIcon?.skin_list?.[this.hero_id]?.[0]?.skin_id
      this.setSkinInfo()
    }
  },  

  methods: {
    setSkinInfo() {
      const curSkin = this.hokIcon?.skin_list?.[this.hero_id]?.find(
        (v) => v.skin_id == this.skin_id
      )
      this.hero_name = this.hokIcon?.hero_list?.find(
        (v) => v.hero_id == this.hero_id
      )?.hero_name
      this.skin_name = curSkin?.skin_name
      this.skin_icon = curSkin?.icon
      this.level = curSkin?.level
      this.skinQuality = curSkin?.quality
    },  

    confirm() {
      this.$refs.tableRef?.fetchData()
      this.setSkinInfo()
    }
  },
}
</script>

<style scoped>
.current_img {
  width: 46px;
  display: inline-block;
  height: 46px;
  margin-right: 5px;
}
.current_img img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.el-form-item :deep(.el-form-item__label) {
  color: #fff;
}
</style>